(function () {

  function initCollectionSlider() {
    document.querySelectorAll('.js-flickity').forEach((elem) => {

        const existing = Flickity.data(elem);

        if (existing) {
            existing.destroy();
        }

        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            resize: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: false,
            draggable: true,
            selectedAttraction: 0.015,
            friction: 0.25,
            accessibility: false
        });

        function toggleNavButtons(flkty) {
            const viewportWidth = flkty.size.innerWidth;
            const contentWidth = flkty.slideableWidth;

            const hasOverflow = contentWidth > viewportWidth;

            if (flkty.prevButton && flkty.nextButton) {
                flkty.prevButton.element.style.display = hasOverflow ? '' : 'none';
                flkty.nextButton.element.style.display = hasOverflow ? '' : 'none';
            }
        }

        toggleNavButtons(flkty);

        flkty.on('resize', () => {
            toggleNavButtons(flkty);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCollectionSlider();
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(initCollectionSlider, 100);
  });

})();